<template>
  <div class="row blaNavbarContainer">
    <div class="col-12 col-md-8 offset-md-2">
      <div class="row">
        <div class="col-4">
          <img
            :src="require('@/assets/img/skillers_logo_2x_mini.png')"
            alt="navbar_logo"
            class="img-fluid blaNavbarLogo clickable"
            @click="$router.push({ name: 'chooser' })"
          />
        </div>
        <div class="col-8 text-right">
          <!-- LeaderBoard -->
          <div class="blaNavbarMailContainer d-inline-block">
            <img
              :src="require('@/assets/img/score.png')"
              alt="leaderBoard"
              class="img-fluid blaNavbarMailIcon blaNavbarAnimation clickable"
              @click="$router.push({ name: 'leaderBoard' })"
            />
            <div v-if="unreadMessages" class="blaNavbarMailIndicator">1</div>
          </div>

          <!--Email icon & marker-->
          <div class="blaNavbarMailContainer d-inline-block">
            <img
              :src="require('@/assets/img/mail_icon.png')"
              alt="mail"
              class="img-fluid blaNavbarMailIcon clickable"
              @click="$router.push({ name: 'messages' })"
            />
            <div v-if="unreadMessages" class="blaNavbarMailIndicator">1</div>
          </div>

          <!--User settings -- profile photo-->
          <img
            v-if="profilePhoto"
            :src="profilePhoto"
            alt="profile_photo"
            class="img-fluid blaNavbarProfilePhoto clickable"
            @click="$router.push({ name: 'settings' })"
          />
          <img
            v-else
            :src="require('@/assets/img/user.png')"
            alt="def_user_profile_photo"
            class="img-fluid blaNavbarProfilePhoto clickable"
            @click="$router.push({ name: 'settings' })"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';

export default {
  components: {},
  data: () => ({
    user: '',
    error: {
      show: false,
      code: '',
      message: '',
      timeout: 3500,
    },
    unreadMessages: false,
  }),
  methods: {
    checkMessage() {
      //Check the unreaded messages
      axios
        .post(this.$store.getters.getApiUrl + '/api/message/checkMessage', {
          token: this.$store.getters.getToken,
          userId: this.$data.user.id,
        })
        .then((response) => {
          // console.log("checkmessage - response: ", response.data);

          //Load the responsed data
          this.$data.unreadMessages = response.data.unreadMessages;
        })
        .catch((error) => {
          if (error.length > 0) {
            console.log('unread message - error: ', error);
          }
        });
    },
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
    profilePhoto() {
      if (
        this.$store.getters.currentUser.profile_photo !== undefined &&
        this.$store.getters.currentUser.profile_photo !== null
      ) {
        return (
          this.$store.getters.getApiUrl +
          '/uploads/profile_photos/' +
          this.$store.getters.currentUser.profile_photo
        );
      } else {
        return (
          this.$store.getters.getApiUrl + '/uploads/profile_photos/default.png'
        );
      }
    },
  },
  mounted: function () {
    //Get the curent user data
    this.$data.user = this.$store.getters.currentUser;

    //Check unread messages
    this.checkMessage();
  },
};
</script>
